<template>
  <div>
    <div class="form-group row">
            <div class="col-md-12">
              <label for="txtName"><small v-show="form.name.required" class="text-danger">*</small>  {{$lang.Sinister.Details.Name}}:</label>
              <div class="input-group">
                <span class="input-group-addon custom-group-addon" @click="showModal=true"><i class="fa fa-plus-circle"></i></span>
                 <autocomplete ref="personTypeahead"
                              v-model="nameSearch"
                              :placeholder="$lang.Sinister.Details.PlaceholderEnterName"
                              :serializer="s => s.text"
                              :data="listNames"
                              @hit="selecteName = $event"
                              inputClass="autocompleteClass"
                              style="width: 100%;padding-left: 40px;"
                              />
              </div>
            </div>
          </div>
          <div class="form-group row pt-2">
            <div class="col-md-4">
              <label for="txtCPFCNPJ"><small v-show="form.cpfCnpj.required" class="text-danger">*</small>  {{$lang.Sinister.Details.CPF_CNPJ}}:</label>
              <div class="input-group">
                <b-form-input type="text"
                              name="txtCPFCNPJ"
                              :placeholder="$lang.Sinister.Details.PlaceholderEnterCPFCNPJ"
                              v-model="form.cpfCnpj.value"
                              :size="form.cpfCnpj.maxlength"
                              :required="form.cpfCnpj.required"
                              :state="form.cpfCnpj.state"
                              :disabled="form.cpfCnpj.disabled"
                              v-mask="['###.###.###-##','##.###.###/####-##','###.###.###/####-##']"/>
              </div>
            </div>
            <div class="col-md-4">
              <label for="txtRG"><small v-show="form.rg.required" class="text-danger">*</small>  {{$lang.Sinister.Details.RG}}:</label>
              <div class="input-group">
                <b-form-input type="text"
                              name="txtRG"
                              :placeholder="$lang.Sinister.Details.PlaceholderEnterRG"
                              v-model="form.rg.value"
                              :size="form.rg.maxlength"
                              :required="form.rg.required"
                              :state="form.rg.state"
                              :disabled="form.rg.disabled"/>
              </div>
            </div>
            <div class="col-md-4">
              <label for="txtCNH"><small v-show="form.cnh.required" class="text-danger">*</small>  {{$lang.Sinister.Details.CNH}}:</label>
              <div class="input-group">
                <b-form-input type="text"
                              name="txtCNH"
                              :placeholder="$lang.Sinister.Details.PlaceholderEnterCNH"
                              v-model="form.cnh.value"
                              :size="form.cnh.maxlength"
                              :required="form.cnh.required"
                              :state="form.cnh.state"
                              :disabled="form.cnh.disabled"/>
              </div>
            </div>
          </div>
          <div class="form-group row">
            <div class="col-md-8">
              <label for="txtAddress"><small v-show="form.address.required" class="text-danger">*</small>  {{$lang.Sinister.Details.Address}}:</label>
              <div class="input-group">
                <b-form-input type="text"
                              name="txtAddress"
                              :placeholder="$lang.Sinister.Details.PlaceholderEnterAddress"
                              v-model="form.address.value"
                              :size="form.address.maxlength"
                              :required="form.address.required"
                              :state="form.address.state"
                              :disabled="form.address.disabled"/>
              </div>
            </div>
            <div class="col-md-4">
              <label for="txtAddressNumber"><small v-show="form.addressNumber.required" class="text-danger">*</small>  {{$lang.Sinister.Details.AddressNumber}}:</label>
              <div class="input-group">
                <b-form-input type="text"
                              name="txtAddressNumber"
                              :placeholder="$lang.Sinister.Details.PlaceholderEnterAddressNumber"
                              v-model="form.addressNumber.value"
                              :size="form.addressNumber.maxlength"
                              :required="form.addressNumber.required"
                              :state="form.addressNumber.state"
                              :disabled="form.addressNumber.disabled"/>
              </div>
            </div>
          </div>
          <div class="form-group row">
            <div class="col-md-4">
              <label for="txtDistrict"><small v-show="form.district.required" class="text-danger">*</small>  {{$lang.Sinister.Details.District}}:</label>
              <div class="input-group">
                <b-form-input type="text"
                              name="txtDistrict"
                              :placeholder="$lang.Sinister.Details.PlaceholderEnterDistrict"
                              v-model="form.district.value"
                              :size="form.district.maxlength"
                              :required="form.district.required"
                              :state="form.district.state"
                              :disabled="form.district.disabled"/>
              </div>
            </div>
            <div class="col-md-4">
              <label for="txtAddressInsured"><small v-show="form.complement.required" class="text-danger">*</small>  {{$lang.Sinister.Details.Complement}}:</label>
              <div class="input-group">
                <b-form-input type="text"
                              name="txtAddressInsured"
                              :placeholder="$lang.Sinister.Details.PlaceholderEnterComplement"
                              v-model="form.complement.value"
                              :size="form.complement.maxlength"
                              :required="form.complement.required"
                              :state="form.complement.state"
                              :disabled="form.complement.disabled" />
              </div>
            </div>
            <div class="col-md-4">
              <label for="txtAddressInsured"><small v-show="form.zipcode.required" class="text-danger">*</small>  {{$lang.Sinister.Details.Zipcode}}:</label>
              <div class="input-group">
                <b-form-input type="text"
                              name="txtAddressInsured"
                              :placeholder="$lang.Common.ZipcodePlaceholder"
                              v-model="form.zipcode.value"
                              :size="form.zipcode.maxlength"
                              :required="form.zipcode.required"
                              :state="form.zipcode.state"
                              v-mask="['#####-###']"
                              :disabled="form.zipcode.disabled"/>
              </div>
            </div>
          </div>
          <div class="form-group row">
            <div class="col-md-4">
              <label for="cbxCountry"> {{$lang.Sinister.Details.LabelCoutry}}:</label>
              <div class="input-group">
                <select class="mb-3 form-control custom-select" disabled>
                  <option value="2375E209-7451-4A7A-A9BE-66BD2C392BE1" selected>BRASIL</option>
                </select>
              </div>
            </div>
            <div class="col-md-4">
              <label for="cbxState"><small v-show="form.stateID.required" class="text-danger">*</small> {{$lang.Sinister.Details.LabelState}}:</label>
              <div class="input-group">
                <b-form-select v-model="form.stateID.value"
                              :options="form.stateID.options"
                              :state="form.stateID.state"
                              :disabled="form.stateID.disabled"
                              @change="onChangeState"
                              class="mb-3"
                              name="cbxState">
                  <template slot="first">
                    <option :value="null" disabled>{{$lang.Common.PlaceholderSelect}}</option>
                  </template>
                </b-form-select>
              </div>
            </div>
            <div class="col-md-4">
              <label for="cbxCity"><small v-show="form.cityID.required" class="text-danger">*</small> {{$lang.Sinister.Details.LabelCity}}:</label>
              <div class="input-group">
                <b-form-select v-model="form.cityID.value"
                              :options="form.cityID.options"
                              :state="form.cityID.state"
                              :disabled="form.cityID.disabled"
                              class="mb-3"
                              name="cbxCity">
                  <template slot="first">
                    <option :value="null" disabled>{{$lang.Common.PlaceholderSelect}}</option>
                  </template>
                </b-form-select>
              </div>
            </div>
          </div>
          <div class="form-group row">
            <div class="col-md-4">
              <label for="txtPhone"><small v-show="form.phoneNumber.required" class="text-danger">*</small>  {{$lang.Sinister.Details.Phone}}:</label>
              <div class="input-group">
                <span class="input-group-addon"><i class="fa fa-phone"></i></span>
                <b-form-input type="text"
                              name="txtPhone"
                              :placeholder="$lang.Common.PhonePlaceholder"
                              v-model="form.phoneNumber.value"
                              :size="form.phoneNumber.maxlength"
                              :required="form.phoneNumber.required"
                              :state="form.phoneNumber.state"
                              :disabled="form.phoneNumber.disabled"
                              v-mask="['(##) ####-####']"  />
              </div>
            </div>
            <div class="col-md-4">
              <label for="txtCellPhone"><small v-show="form.cellNumber.required" class="text-danger">*</small>  {{$lang.Sinister.Details.CellPhone}}:</label>
              <div class="input-group">
                <span class="input-group-addon"><i class="fa fa-mobile-phone"></i></span>
                <b-form-input type="text"
                              name="txtCellPhone"
                              :placeholder="$lang.Common.MobilePhonePlaceholder"
                              v-model="form.cellNumber.value"
                              :size="form.cellNumber.maxlength"
                              :required="form.cellNumber.required"
                              :state="form.cellNumber.state"
                              :disabled="form.cellNumber.disabled"
                              v-mask="['(##) ####-####', '(##) # ####-####']"  />
              </div>
            </div>
            <div class="col-md-4">
              <label for="txtEmail">{{$lang.Sinister.Details.EmailMachineWorkshop}}:</label>
              <div class="input-group">
                <span class="input-group-addon"><i class="fa fa-envelope"></i></span>
                <b-form-input type="text"
                              name="txtEmail"
                              :placeholder="$lang.Sinister.Details.PlaceholderEmail"
                              v-model="form.email.value"
                              :size="form.email.maxlength"
                              :required="form.email.required"
                              :state="form.email.state"
                              :disabled="form.email.disabled"/>
              </div>
            </div>
          </div>

    <b-modal v-model="showModal" size="lg" title="CADASTRO DE SEGURADOS (CONDUTOR E TERCEIROS)" :header-bg-variant="'info'">
      <div>
        <Insured/>
      </div>
        <div slot="modal-footer" class="w-100">
          <button type="button" title="" size="sm" class="float-right btn btn-default btn-sm text-secundary" @click="showModal=false">
            <i class="fa fa-times-circle"></i> Fechar
          </button>
        </div>
    </b-modal>
  </div>
</template>
<script>
import Person from './person.js'
export default Person
</script>
<style lang="scss" scoped>
.custom-group-addon {
  display: block;
  position: absolute;
  z-index: 9;
  cursor: pointer;
  margin-right: 65px;
}
.autocompleteClass {
  padding-left: 65px;
}
</style>



// WEBPACK FOOTER //
// src/components/regulation/auto/person/person.vue